import React from "react";
import { Link } from "react-router-dom";

export default function Home() {
  return (
    <div className="container mx-auto">
      {/* Hero Section */}
      <aside className="position-relative overflow-hidden bg-light rounded-lg p-4">
        <div className="row align-items-center py-5">
          {/* Text Section */}
          <div className="col-md-6 text-center text-md-end">
            <h2 className="display-4 fw-bold">
              Download Now
              <span className="d-block">Lorem Ipsum</span>
            </h2>

            <Link
              className="btn btn-warning text-white px-4 py-2 mt-4 d-inline-flex align-items-center"
              to="/"
            >
              <svg
                fill="white"
                width="24"
                height="24"
                xmlns="http://www.w3.org/2000/svg"
                fillRule="evenodd"
                clipRule="evenodd"
              >
                <path d="M1.571 23.664l10.531-10.501 3.712 3.701-12.519 6.941c-.476.264-1.059.26-1.532-.011l-.192-.13zm9.469-11.56l-10.04 10.011v-20.022l10.04 10.011zm6.274-4.137l4.905 2.719c.482.268.781.77.781 1.314s-.299 1.046-.781 1.314l-5.039 2.793-4.015-4.003 4.149-4.137zm-15.854-7.534c.09-.087.191-.163.303-.227.473-.271 1.056-.275 1.532-.011l12.653 7.015-3.846 3.835-10.642-10.612z" />
              </svg>
              &nbsp; Download now
            </Link>
          </div>

          {/* Image Section */}
          <div className="col-md-6 text-center">
            <img
              className="img-fluid w-50"
              src="https://i.ibb.co/5BCcDYB/Remote2.png"
              alt="image1"
            />
          </div>
        </div>
      </aside>

      {/* Centered Image */}
      <div className="d-flex justify-content-center mt-5">
        <img
          className="img-fluid w-50"
          src="https://i.ibb.co/2M7rtLk/Remote1.png"
          alt="image2"
        />
      </div>

      {/* Title */}
      <h1 className="text-center display-4 py-5 fw-bold">Lorem Ipsum Yojo</h1>
    </div>
  );
}
